<template>
  <div
    class="d-flex auth-form-body"
    :style="minHeight ? `min-height:${minHeight}px` : ''"
  >
    <div class="w-50 d-flex align-items-center shadow-lg position-relative">
      <div class="px-5" ref="companyProfile">
        <AuthCompanyProfile />
      </div>
    </div>
    <div class="w-50 d-flex align-items-center auth-suggestion">
      <div class="w-50 mx-auto" ref="authForm">
        <form @submit.prevent="handleSubmit" novalidate>
          <h3 class="mb-4 text-center">ავტორიზაცია</h3>
          <div class="mb-3">
            <label class="form-label">ელ. ფოსტა</label>
            <input
              type="email"
              class="form-control"
              :class="{ 'is-invalid': emailError }"
              v-model="email"
              @focus="emailError = false"
            />
            <div v-if="emailError" class="invalid-feedback">
              {{ emailErrorMessage }}
            </div>
          </div>
          <div class="mb-3 position-relative">
            <label class="form-label">პაროლი</label>
            <input
              :type="showPassword ? 'text' : 'password'"
              class="form-control"
              :class="{ 'is-invalid': passwordError }"
              v-model="password"
              @focus="passwordError = false"
            />
            <div class="show-password" @click="showPassword = !showPassword">
              <span v-if="!showPassword" class="material-icons text-secondary">
                visibility
              </span>
              <span v-if="showPassword" class="material-icons text-secondary">
                visibility_off
              </span>
            </div>
            <div v-if="passwordError" class="invalid-feedback">
              {{ passwordErrorMessage }}
            </div>
          </div>
          <div
            v-if="serverError"
            class="alert alert-danger mb-3 text-center"
            role="alert"
          >
            {{ serverErrorMessage }}
          </div>
          <div class="text-center mb-3">
            <button
              type="submit"
              class="btn btn-primary rounded-pill px-4 font-caps"
            >
              შესვლა
            </button>
          </div>
        </form>
        <div class="mb-4 text-center">
          <router-link
            :to="{ name: 'forgotPassword' }"
            class="text-decoration-none"
            >პაროლის აღდგენა</router-link
          >
        </div>
        <div class="text-center">
          გაიარეთ
          <router-link :to="{ name: 'signup' }" class="text-decoration-none"
            >რეგისტრაცია</router-link
          >
          თუ ჯერ არ გაქვთ ანგარიში
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from "@vue/reactivity";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import AuthCompanyProfile from "@/components/AuthCompanyProfile.vue";
import useAuthMinHeight from "@/composables/useAuthMinHeight";

export default {
  components: { AuthCompanyProfile },
  setup() {
    const store = useStore();
    const router = useRouter();

    const email = ref("");
    const password = ref("");

    const emailError = ref(false);
    const emailErrorMessage = ref("");
    const passwordError = ref(false);
    const passwordErrorMessage = ref("");
    const serverError = ref(false);
    const serverErrorMessage = ref("");

    const { minHeight, companyProfile, authForm } = useAuthMinHeight();

    const showPassword = ref(false);

    const handleSubmit = async () => {
      if (email.value.length === 0) {
        emailError.value = true;
        emailErrorMessage.value = "ელ. ფოსტის ველი ცარიელია";
      } else if (!/\S+@\S+\.\S+/.test(email.value)) {
        emailError.value = true;
        emailErrorMessage.value = "ელ. ფოსტის მისამართი არასწორია";
      }

      if (password.value.length === 0) {
        passwordError.value = true;
        passwordErrorMessage.value = "პაროლის ველი ცარიელია";
      }

      if (!emailError.value && !passwordError.value) {
        try {
          await store.dispatch("signin", {
            email: email.value,
            password: password.value,
          });

          router.push({ name: "home" });
        } catch (error) {
          serverError.value = true;
          serverErrorMessage.value = error.message;
        }
      } else {
        serverError.value = false;
      }
    };

    return {
      email,
      password,
      handleSubmit,
      emailError,
      emailErrorMessage,
      passwordError,
      passwordErrorMessage,
      serverError,
      serverErrorMessage,
      showPassword,
      companyProfile,
      authForm,
      minHeight,
    };
  },
};
</script>

<style>
</style>